export function maskTEL(v) {
  if (!v) return ''

  if (v.length >= 16) return v.substr(0, 16)

  return v.replace(/\D/g, "")
          .replace(/^(\d{2})(\d)/g, "($1) $2")
          .replace(/(\d)(\d{4})$/, "$1-$2")
}

export function maskCPF(v) {
  if (!v) return ''

  if (v.length >= 14) return v.substr(0, 14)

  return v.replace(/\D/g, "")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function maskCNPJ(v) {
  if (!v) return ''

  if (v.length >= 18) return v.substr(0, 18)

  return v.replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1/$2")
          .replace(/(\d)(\d{2})$/, "$1-$2");
}

export function maskIE(v) {
  if (!v) return ''

  return v.replace(/\D/g, "")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
}

export function maskRG(v) {
  if (!v) return ''

  if (v.length >= 12) return v.substr(0, 12)

  return v.replace(/(\d{2})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{5})(\d)/, "$1.$2")
          .replace(/(\d{9})(\d)/, "$1-$2")
}

export function maskCEP(v) {
  if (!v) return ''

  if (v.length >= 9) return v.substr(0, 9)

  return v.replace(/\D/g, "")
          .replace(/^(\d{5})(\d)/, "$1-$2")
}

export function maskCARTAO(v) {
  if (!v) return ''

  return v.replace(/\D/g, "")
          .replace(/(\d{4})(\d)/, "$1.$2")
          .replace(/(\d{4})(\d)/, "$1.$2")
          .replace(/(\d{4})(\d)/, "$1.$2")
          .replace(/(\d{4})(\d)/, "$1.$2")
}

export function maskDATA(v) {
  if (!v) return ''

  if (v.length >= 10) return v.substr(0, 10)

  return v.replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1/$2")
        .replace(/(\d{2})(\d)/, "$1/$2")
}

export function maskVALOR(v) {
  if (!v) return ''

  return v.replace(/\D/g, "")
          .replace(/(\d)(\d{8})$/, "$1.$2")
          .replace(/(\d)(\d{5})$/, "$1.$2")
          .replace(/(\d)(\d{2})$/, "$1,$2")
}

export function maskEMAIL(v) {
  if (!v) return ''

  return v.replace(/\s/g, "");
}
